import { forwardRef } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { Container, Input } from './TextInput.styled';

const TextInput = forwardRef<
	HTMLInputElement,
	React.HTMLAttributes<HTMLInputElement>
>((props, ref) => {
	return (
		<Container onMouseEnter={() => playSound(Sound.LinkCursor)}>
			<Input ref={ref} tabIndex={-1} {...props} />
		</Container>
	);
});

export { TextInput };
